import {html} from 'lit';
import {
	selectRegion,
	selectSpcIsSatisfied
} from './selectors';

import {solarSectionConfig} from './solar/solarSectionConfig';
import {olivioSectionConfig} from './olivio/olivioSectionConfig';
import {iomoSectionConfig} from './iomo/iomoSectionConfig';
import {lineColumnBollard, lineColumnIntern, lineBollardIntern, lineSingular, lineSingularIntern} from './line/lineSectionConfig';
import {lightProfile} from './lightProfile/lightProfileSectionConfig';
import {generalAttributeOptions} from './generalAttributeOptions';


export const sectionConfigs = {
	General: [
		{
			id: 'default',
			label: null,
			visual: null,
			features: [],
			useAttributesView: true,
			attributeOptions: generalAttributeOptions,
			widgets: null,
			widgetsBasic: null,
			widgetsEnd: []
		}
	],
	ColumnBollard: lineColumnBollard,
	ColumnIntern: lineColumnIntern,
	BollardIntern: lineBollardIntern,
	Singular: lineSingular,
	SingularIntern: lineSingularIntern,
	LightProfile: lightProfile,
	Aeto: solarSectionConfig,
	Olivio: olivioSectionConfig,
	Iomo: iomoSectionConfig,
	Start: [
		{
			id: 'family',
			label: {
				de: 'Familie wählen',
				en: 'Select Family',
				fr: 'Select Family',
			},
			visual: null,
			features: [],
			widgets: [
				html`
					<family-select></family-select>`
			]
		}
	],
	Default: [
		{
			id: 'default',
			label: {
				de: 'Default',
				en: 'Default',
				fr: 'Default',
			},
			visual: null,
			features: []
		}
	]
};

// pick sectionConfig depending on featureModelId
export const sections = {
	Start: {
		default: sectionConfigs.Start
	},

	Line: {
		default: sectionConfigs.ColumnBollard,
		External: {
			Column: sectionConfigs.ColumnBollard,
			Bollard: sectionConfigs.ColumnBollard,
			Twist06: sectionConfigs.Singular,
			Twist12: sectionConfigs.Singular,
			PoleLateral: sectionConfigs.Singular,
			PoleTop: sectionConfigs.Singular,
			WallSurface: sectionConfigs.Singular,
			WallRecessed: sectionConfigs.Singular,
		},
		Internal: {
			Column: sectionConfigs.ColumnIntern,
			Bollard: sectionConfigs.BollardIntern,
			Twist06: sectionConfigs.SingularIntern,
			Twist12: sectionConfigs.SingularIntern,
			PoleLateral: sectionConfigs.SingularIntern,
			PoleTop: sectionConfigs.SingularIntern,
			WallSurface: sectionConfigs.SingularIntern,
			WallRecessed: sectionConfigs.SingularIntern,
		},
	},
	LightProfile: {
		default: sectionConfigs.LightProfile
	},
	Aeto: {
		default: sectionConfigs.Aeto
	},
	Olivio: {
		default: sectionConfigs.Olivio
	},


	Line2: {
		default: sectionConfigs.General,
	},
	Avanza: {
		default: sectionConfigs.General,
		External: {
			Avanza: sectionConfigs.General,
		},
		Internal: {
			Avanza: sectionConfigs.General,
		},
	},
	Tal: {
		default: sectionConfigs.General
	},
	Saturn: {
		default: sectionConfigs.General
	},
	Lanova: {
		default: sectionConfigs.General
	},
	Aya: {
		default: sectionConfigs.General
	},
	Yloo: {
		default: sectionConfigs.General
	},
	Aeto2: {
		default: sectionConfigs.General
	},
	Olivio2: {
		default: sectionConfigs.General
	},
	Iomo: {
		default: sectionConfigs.Iomo
	},
	default: sectionConfigs.General
};

export function getSectionConfig(family, mode, housingType = 'default') {
	if (!mode) mode = 'External';
	if (family && mode && housingType && sections[family][mode] && sections[family][mode][housingType]) {
		return sections[family][mode][housingType];
	} else if (family && sections[family]) {
		return sections[family].default;
	} else {
		return sections.default;
	}

}

